import { render, staticRenderFns } from "./wasteBlackInfo.vue?vue&type=template&id=72b2d982&scoped=true&"
import script from "./wasteBlackInfo.vue?vue&type=script&lang=js&"
export * from "./wasteBlackInfo.vue?vue&type=script&lang=js&"
import style0 from "./wasteBlackInfo.vue?vue&type=style&index=0&id=72b2d982&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2d982",
  null
  
)

export default component.exports